import { useQuery, gql } from "@apollo/client"
import { offsetLimitPagination } from "@apollo/client/utilities"

export const QUERY_LIST_CUSTOM_FIELDS = gql`
  query CustomFields($limit: Int, $offset: Int) {
    customFields {
      list(limit: $limit, offset: $offset) {
        ... on BooleanCustomField {
          id
          name
          __typename
          customFieldType
        }
        ... on StringCustomField {
          id
          name
          __typename
          customFieldType
        }
        ... on NumberCustomField {
          id
          name
          __typename
          customFieldType
        }
        ... on DateCustomField {
          id
          name
          __typename
          customFieldType
        }
      }
    }
  }
`

export const useQueryCustomFields = (options) => useQuery(QUERY_LIST_CUSTOM_FIELDS, options)

export const customFieldTypePolicies = {
  scoped: {
    CustomFieldsQuery: {
      merge(prev, next) {
        return {
          ...(prev || {}),
          ...next
        }
      },
      fields: {
        list: offsetLimitPagination(["filter"])
      }
    }
  }
}
